import { API_BASE } from "./shared/ktt-host";

export async function makeRequest({ endpoint, method, body }) {
  const config = {
    method: method,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
  };

  if (body) {
    config.body = JSON.stringify(body);
  }

  return await fetch(API_BASE + endpoint, config);
}

document.addEventListener("submit-data", async (event) => {
  const response = await makeRequest({
    endpoint: event.detail.endpoint,
    method: event.detail.method,
    body: event.detail.payload,
  });

  event.detail.response = response;

  if (response.status === 200) {
    window.start();
  }
});
